import { useTranslation } from 'react-i18next';
import { ClbCheckbox, ClbIcon, ClbTag, ClbTooltip } from '@celebration/react';
import { useCallback } from 'react';
import { ILoadCardHeader } from './ILoadCardHeader';
import './load-card-header.scss';

export default function LoadCardHeader(props: Readonly<ILoadCardHeader>) {
    const {
        tag,
        loadId,
        showLoadId,
        checked,
        checkBoxRef,
        handleCardSelected,
        handleCardUnselected,
        isPrioritized,
        checkboxDisabled,
        insertedMidRound = false,
    } = props;

    const { t } = useTranslation();

    const insertedMidRoundBackground = insertedMidRound
        ? 'tag-inserted-mid-round'
        : '';

    const getLoadTagElement = () => {
        return (
            <div className={`load-card-tag ${insertedMidRoundBackground}`}>
                <ClbTag
                    id={tag.id}
                    type={tag.type}
                    data-testid={tag.dataTestId}
                    style={{ maxWidth: 120 }}
                >
                    {t(tag.label)}
                </ClbTag>
            </div>
        );
    };

    const onChangeCheckboxLoadId = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            if (checked) {
                handleCardUnselected!(loadId);
                e.target.parentElement
                    ?.querySelector('span[class=checkmark--checked]')
                    ?.classList.remove('checkmark--checked');
            } else {
                handleCardSelected!(loadId);
                e.target.parentElement
                    ?.querySelector('span[class=checkmark]')
                    ?.classList.add('checkmark--checked');
            }
        },
        [checked, handleCardSelected, handleCardUnselected, loadId],
    );

    return (
        <div className="card-loads-header">
            <div className="card-loads__leftSide">
                {!checkboxDisabled && (
                    <ClbCheckbox
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            onChangeCheckboxLoadId(e)
                        }
                        ref={checkBoxRef}
                        checked={checked}
                        data-testid="card-loads__idLoad-checkbox"
                        className={`${checked ? 'checkmark--checked' : ''}`}
                    >
                        <div />
                    </ClbCheckbox>
                )}
                {showLoadId && (
                    <div
                        style={{
                            fontWeight: `${checked ? 600 : 'normal'}`,
                        }}
                    >
                        {loadId}
                    </div>
                )}
            </div>
            <div className="card-loads__rightSide">
                <ClbTooltip
                    description={tag.label}
                    position="top"
                    showArrow
                    colorMode="dark"
                >
                    {getLoadTagElement()}
                </ClbTooltip>
                {isPrioritized && (
                    <div
                        className="card-loads__prioritizedIcon"
                        data-testid="card-loads__prioritizedIcon"
                    >
                        <ClbIcon icon="star-1" size="md" />
                    </div>
                )}
            </div>
        </div>
    );
}
